import React, { useState } from 'react';
import './FirmNameStep.scss';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectWizard } from '../../contexts/ProjectWizardContext';
import Loader from '../../../../../shared/components/common/loader/Loader';
import { getQuestions } from '../../../../../shared/services/projects/ProjectService';

const FirmNameStep: React.FC = () => {
  const { setActiveStep, setQuestionResponse, setFirmName } = useProjectWizard();
  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [apiError, setApiError] = useState<string | null>(null);

  const onSubmit = async (loginFormData: any) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setLoading(true);
    const firmName = loginFormData.firmName.trim();
    getQuestions(firmName, false)
      .then((data) => {
        setLoading(false);
        setQuestionResponse(data);
        setActiveStep('QUESTIONS');
        setFirmName(firmName);
      })
      .catch((err) => {
        setLoading(false);
        setApiError(err.message);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      {loading && <Loader loadingLabel="loadingDataThisMayTakeAMoment" />}
      <form onSubmit={handleSubmit(onSubmit)} className="project-wizard__page-box">
        <div className="project-wizard__form">
          <div className="form-box__row">
            <h2>{t('enterBrandName')}</h2>
            <div
              className="project-wizard__desc"
              dangerouslySetInnerHTML={{ __html: t('enterBrandNameDesc') }}
            />
            <div className="form-box__label">{t('brandName')}:</div>
            <InputText
              {...register('firmName', {
                required: t('fieldIsRequired'),
              })}
              placeholder="Example"
              className={errors.firmName || apiError ? 'form-box__invalid' : ''}
            />
            {errors.firmName && <span>{errors.firmName.message as string}</span>}
          </div>
        </div>
        <div className="project-wizard__action">
          <Button className="btn btn--sm" type="submit" disabled={isSubmitting}>
            {t('next')}
          </Button>
          <div className="project-wizard__link">
            {t('linkToDomainStep')}
            <Button
              className="btn--link btn--link-black"
              label={t('clickHere')}
              onClick={() => setActiveStep('DOMAIN')}
            />
          </div>
          <div className="project-wizard__note">{t('noteHistorical')}</div>
        </div>
      </form>
    </>
  );
};

export default FirmNameStep;
